import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  IUpshifterExperience,
  IUpshifterExperienceReducer,
} from 'models/UpshifterExperience'
import { addToArray, updateArray } from 'helpers/helperFuncs'
import { deleteFromArray } from 'helpers/helperFuncs'
import {
  UpshifterExperiencesFetching,
  GetUpshifterExperiences,
  GetUpshifterExperiencesErrors,
  UpdateUpshifterExperience,
  AddUpshifterExperience,
  DeleteUpshifterExperience,
  GetIsEditExperienceModal,
  GetUpshifterExperienceEnums,
  ClearUpshifterExperienceReducer,
} from './actions'

const initialState: IUpshifterExperienceReducer = {
  meta: {
    message: '',
    code: 0,
  },
  isFetching: false,
  data: [],
}

export const upshifterExperiencesReducer = (
  state = initialState,
  action: Action,
): IUpshifterExperienceReducer => {
  if (isType(action, GetUpshifterExperiences)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, UpshifterExperiencesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, GetUpshifterExperiencesErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }
  if (isType(action, UpdateUpshifterExperience)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IUpshifterExperience>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, AddUpshifterExperience)) {
    const { payload } = action
    const { data } = state
    const formattedArray = addToArray<IUpshifterExperience>(payload.data, data)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, DeleteUpshifterExperience)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IUpshifterExperience>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, GetIsEditExperienceModal)) {
    const { payload } = action
    return {
      ...state,
      isEditExperienceModal: payload,
    }
  }

  if (isType(action, GetUpshifterExperienceEnums)) {
    const { payload } = action
    return {
      ...state,
      enums: payload,
    }
  }

  if (isType(action, ClearUpshifterExperienceReducer)) {
    return {
      ...initialState,
    }
  }

  return state
}
